import { useMemo } from "react";

type FontConfig = {
    hostnames: string[];
    fontFamily: string;
    fontFaces: string;
};

const FONT_CONFIGS: FontConfig[] = [
    {
        hostnames: [
            "myvitalityglobal-admin2.golazo-energy.com",
            "wellbe-admin2.golazo-energy.com"
        ],
        fontFamily: `
          font-family: INGMeCyWeb, arialCE;
    font-feature-settings: "tnum";
    font-kerning: auto;
    font-optical-sizing: auto;
    font-size: 14px;
    font-stretch: 100%;
    font-style: normal;
    font-variant-numeric: tabular-nums;
    font-weight: 400;
        `,
        fontFaces: `
      @font-face {
        font-family: "INGMeCyWeb";
        src:
          url("/fonts/ing/INGMeCyWeb/INGMeCyWeb-Regular.woff2") format("woff2"),
          url("/fonts/ing/INGMeCyWeb/INGMeCyWeb-Regular.woff") format("woff");
        font-weight: 400;
      }

      @font-face {
        font-family: "INGMeCyWeb";
        src:
          url("/fonts/ing/INGMeCyWeb/INGMeCyWeb-Bold.woff2") format("woff2"),
          url("/fonts/ing/INGMeCyWeb/INGMeCyWeb-Bold.woff") format("woff");
        font-weight: 600;
      }

      @font-face {
        font-family: "INGMeCyWeb";
        src:
          url("/fonts/ing/INGMeCyWeb/INGMeCyWeb-Bold.woff2") format("woff2"),
          url("/fonts/ing/INGMeCyWeb/INGMeCyWeb-Bold.woff") format("woff");
        font-weight: 800;
      }

      @font-face {
        font-family: "arialCE";
        src: url("/fonts/ing/arialCE/ArialCE-Regular.ttf") format("truetype");
        font-weight: 400;
      }

      @font-face {
        font-family: "arialCE";
        src: url("/fonts/ing/arialCE/ArialCE-Bold.ttf") format("truetype");
        font-weight: 600;
      }

      @font-face {
        font-family: "arialCE";
        src: url("/fonts/ing/arialCE/ArialCE-Black.ttf") format("truetype");
        font-weight: 800;
      }
    `
    },
    {
        hostnames: [
            "pwc-admin2.golazo-energy.com", "pwc-staging-admin2.golazo-energy.com"

        ],
        fontFaces: `
        @font-face {
    font-family: "helveticaNeue";
    src:  url('/fonts/pwc/helveticaNeue/HelveticaNeue-Regular.woff2') format('woff2'),
    url('/fonts/pwc/helveticaNeue/HelveticaNeue-Regular.woff') format('woff');
    font-weight: 400;
}

@font-face {
    font-family: "helveticaNeue";
    src:  url('/fonts/pwc/helveticaNeue/HelveticaNeue-Medium.woff2') format('woff2'),
    url('/fonts/pwc/helveticaNeue/HelveticaNeue-Medium.woff') format('woff');
    font-weight: 600;
}

@font-face {
    font-family: "helveticaNeue";
    src:  url('/fonts/pwc/helveticaNeue/HelveticaNeue-Bold.woff2') format('woff2'),
    url('/fonts/pwc/helveticaNeue/HelveticaNeue-Bold.woff') format('woff');
    font-weight: 800;
}

@font-face {
    font-family: "charterITC";
    src:  url('/fonts/pwc/charterITC/CharterITCW05-Regular.woff2') format('woff2'),
    url('/fonts/pwc/charterITC/CharterITCW05-Regular.woff') format('woff');
    font-weight: 400;
}

@font-face {
    font-family: "charterITC";
    src:  url('/fonts/pwc/charterITC/CharterITCW05-Bold.woff2') format('woff2'),
    url('/fonts/pwc/charterITC/CharterITCW05-Bold.woff') format('woff');
    font-weight: 600;
}

@font-face {
    font-family: "charterITC";
    src:  url('/fonts/pwc/charterITC/CharterITCW05-Black.woff2') format('woff2'),
    url('/fonts/pwc/charterITC/CharterITCW05-Black.woff') format('woff');
    font-weight: 800;
}
        `,
        fontFamily: `
          font-family: "charterITC", Georgia, serif !important;
          h2 span,
.h2 span {
  color: #fd5108 !important;
  font-weight: 400 !important;
  line-height: 22px !important;
  font-size: 16px !important;
  position: relative;
  font-family: "helveticaNeue", sans-serif !important;
}
        `
    },
    {
        hostnames: ["kpmg-admin2.golazo-energy.com"],
        fontFaces: `
        @font-face {
    font-family: "kpmg";
    src:  url('/fonts/kpmg/KPMG-Light151009.woff2') format('woff2'),
    url('/fonts/kpmg/KPMG-Light151009.woff') format('woff');
    font-weight: 400;
}
        `,
        fontFamily: `
         
         h1 {
          font-family: "kpmg", sans-serif;
         }
         h2 {
    font-family: 'Arial' !important;
    font-size: 20px !important;
}
        `
    }
];

const DEFAULT_FONT_CONFIG: Omit<FontConfig, "hostnames"> = {
    fontFamily: "Poppins, sans-serif",
    fontFaces: ""
};

export function useClientFonts() {
    return useMemo(() => {
        const hostname = window.location.hostname.toLowerCase();

        const config = FONT_CONFIGS.find((c) => c.hostnames.some(
            (host) => host.toLowerCase() === hostname
        ));

        return config
            ? {
                fontFamily: config.fontFamily,
                fontFaces: config.fontFaces
            }
            : DEFAULT_FONT_CONFIG;
    }, []);
}
